import { useCallback, useEffect } from "react";

import { useQuery } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

function useCountEntitiesToDelete(onDone) {
  const queryFactory = useCallback(() => {
    const query = `query countEntitiesToDelete {
                    searchClients {
                      totalCount
                    }
                  }`;

    const resolver = ({ data: { searchClients } }) => {
      return {
        totalClients: searchClients?.totalCount || 0,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { data, error, numOfFetches, loading } = useQuery(queryFactory);

  useEffect(() => {
    if (data?.totalClients > 0 || loading || (numOfFetches === 0 && !error)) {
      onDone(false);
    } else if (
      data?.totalClients === 0 ||
      (Array.isArray(data) && data?.length === 0)
    ) {
      onDone(true);
    }
  }, [data, loading, numOfFetches, error, onDone]);

  return {
    data: Array.isArray(data) && data?.length === 0 ? null : data,
    loading: loading || (numOfFetches === 0 && !error),
    hasError: Boolean(error),
  };
}

export default useCountEntitiesToDelete;
